var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"notifications"},[(_vm.alert.message)?_c('notification',{attrs:{"horizontalAlign":"center","icon":"tim-icons icon-bell-55","message":_vm.alert.message,"type":_vm.alert.type},on:{"close":_vm.clearAlert}}):_vm._e()],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }